import React from "react";
import RubricBank from "./RubricBank";
import CommentBank from "./CommentBank";
import Tabs from "../../../Events/Tabs/Tabs";

const AssignmentSettings = ({ user, isMobileView, isNew, setIsNew }) => {
  return (
    <Tabs currentTab="Rubric Bank">
      <div label="Rubric Bank">
        <RubricBank
          user={user}
          isMobileView={isMobileView}
          isNew={isNew}
          setIsNew={setIsNew}
        />
      </div>
      <div label="Comment Bank">
        <CommentBank user={user} />
      </div>
    </Tabs>
  );
};

export default AssignmentSettings;
